export enum DragTypeEnum {
  NOT_DRAGGING = "NOT_DRAGGING",
  KANBAN_PASSENGER = "KANBAN_PASSENGER",
  KANBAN_RIDE = "KANBAN_RIDE",
  CARD_BOARD_RIDE = "CARD_BOARD_RIDE",
  GRID_PASSENGER = "GRID_PASSENGER",
  STATION = "STATION",
  GRID_RIDE = "GRID_RIDE",
}
